"use client";

import { datadogRum } from "@datadog/browser-rum";
import { useEffect } from "react";

let initialized = false;

export function DatadogRum() {
  useEffect(() => {
    if (initialized) return;
    initialized = true;

    datadogRum.init({
      applicationId:
        process.env.NEXT_PUBLIC_DD_APPLICATION_ID ??
        "a6de34bf-86ad-47b6-8e25-49a62003de7c",
      clientToken:
        process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN ??
        "pubdb7e1187f1bf05a3c3a90b9dc8c5f276",
      site: "us3.datadoghq.com",
      service: "hoai-v2-web",
      env: process.env.NEXT_PUBLIC_DD_ENV ?? "development",
      version: process.env.NEXT_PUBLIC_DD_VERSION ?? "v2",
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
      allowedTracingUrls: [
        {
          match: /\.myhoai\.com/,
          propagatorTypes: ["datadog", "tracecontext"],
        },
        { match: /localhost/, propagatorTypes: ["datadog", "tracecontext"] },
      ],
    });
  }, []);

  return null;
}
